import { cn } from '@natu/utils/cn';

import type { TypographyVariant, TypographyVariantProp } from '../../Typography.type';

type VariantOptions = Record<TypographyVariant, string>;

export const typographyVariantsMobile: VariantOptions = {
  'text-8xl': 'text-8xl',
  'display-2xl': 'text-7xl',
  'display-xl': 'text-6xl',
  'display-lg': 'text-5xl',
  'display-md': 'text-4xl',
  'display-sm': 'text-3xl',
  'display-xs': 'text-2xl',
  'text-xl': 'text-xl',
  'text-lg': 'text-lg',
  'text-md': 'text-base',
  'text-sm': 'text-sm',
  'text-xs': 'text-xs',
  'text-[54px]': 'text-[54px]',
  'text-sm-13': 'text-[13px]',
  'text-sm-15': 'text-[15px]',
  'display-sm-28': 'text-display-sm-28',
  'display-md-34': 'text-display-md-34',
  'display-lg-46': 'text-display-lg-46',
  'display-xl-58': 'text-display-xl-58',
};

const typographyVariantsTablet: VariantOptions = {
  'text-8xl': 'md:text-8xl',
  'display-2xl': 'md:text-7xl',
  'display-xl': 'md:text-6xl',
  'display-lg': 'md:text-5xl',
  'display-md': 'md:text-4xl',
  'display-sm': 'md:text-3xl',
  'display-xs': 'md:text-2xl',
  'text-xl': 'md:text-xl',
  'text-lg': 'md:text-lg',
  'text-md': 'md:text-base',
  'text-sm': 'md:text-sm',
  'text-xs': 'md:text-xs',
  'text-[54px]': 'md:text-[54px]',
  'text-sm-13': 'md:text-[13px]',
  'text-sm-15': 'md:text-[15px]',
  'display-sm-28': 'md:text-display-sm-28',
  'display-md-34': 'md:text-display-md-34',
  'display-lg-46': 'md:text-display-lg-46',
  'display-xl-58': 'md:text-display-xl-58',
};

const typographyVariantsDesktop: VariantOptions = {
  'text-8xl': 'xl:text-8xl',
  'display-2xl': 'xl:text-7xl',
  'display-xl': 'xl:text-6xl',
  'display-lg': 'xl:text-5xl',
  'display-md': 'xl:text-4xl',
  'display-sm': 'xl:text-3xl',
  'display-xs': 'xl:text-2xl',
  'text-xl': 'xl:text-xl',
  'text-lg': 'xl:text-lg',
  'text-md': 'xl:text-base',
  'text-sm': 'xl:text-sm',
  'text-xs': 'xl:text-xs',
  'text-[54px]': 'xl:text-[54px]',
  'text-sm-13': 'xl:text-[13px]',
  'text-sm-15': 'xl:text-[15px]',
  'display-sm-28': 'xl:text-display-sm-28',
  'display-md-34': 'xl:text-display-md-34',
  'display-lg-46': 'xl:text-display-lg-46',
  'display-xl-58': 'xl:text-display-xl-58',
};

export const getTypographyVariantStyles = (variant?: TypographyVariantProp) => {
  if (typeof variant === 'string') {
    return cn(typographyVariantsMobile[variant]);
  }

  if (Array.isArray(variant) && variant.length > 0) {
    const [mobile, tablet, desktop] = variant;

    return cn(
      typographyVariantsMobile[mobile],
      tablet && typographyVariantsTablet[tablet],
      desktop && typographyVariantsDesktop[desktop],
    );
  }

  return 'text-inherit';
};
